import * as React from 'react'
import * as Container from "../../container/container";

const Video = (key) => {
    return (
        <Container.Part background="beige" key={key}>
            <Container.Row>
                <div className="col-12">
                    <div className="inner-container">
                        <h2>Ein Besuch in Wohlmuthshüll.</h2>
                        <figure className="video">
                            <div className="yt-container yt-enabled">
                                <Container.Video
                                    url={"/videos/Filmmaterial/008_Wohlmuthshüll/210930_Wohlmuthshüll mit Intro.mp4"}
                                    poster={"/images/Videowallpaper/wohlmuthshuell.jpg"}/>
                            </div>
                        </figure>
                    </div>
                </div>
            </Container.Row>
        </Container.Part>
    )
}

export default Video
